import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { MultiSetsPromotionModule, MultiSetsPromotionModuleEvents, MultiSetsPromotionStates } from '@gongxigames/framework/promotions';

export class MultiSetsPromotionRestoreState extends ModuleState<null, MultiSetsPromotionModule, MultiSetsPromotionModuleEvents> {
    public onEnterState(): void {
        if (this.isRestorePromotionAfterStartGame()) {
            this.emit('General.Flow.WAIT_EVENT_BEFORE_RESTORE_GAME', 'MultiSetsPromotion.START_STATE_LEFT');
        }
    }

    protected setupEvents(): void {
        if (this.isRestorePromotionAfterStartGame()) {
            this.setEventHandler('General.Flow.WAITING_OF_RESTORE_GAME', this.startPromotion.bind(this));
        } else {
            this.setEventHandler('General.Flow.PAID_ROUND_ENDED', this.startPromotion.bind(this));
        }
    }

    protected startPromotion(): void {
        this.module.gotoState(MultiSetsPromotionStates.START);
    }

    protected isRestorePromotionAfterStartGame(): boolean {
        return this.module.nextActionIsSpin || this.module.getPromotion().isActive();
    }

    public onLeaveState(): void {}
}
